import React, { Component } from 'react';

import Logout from '../../../views/LoginPage/Logout';
import fire from '../../../views/LoginPage/fire';

export default class ConfigScreen extends Component {

    handleLogout = () => {
        fire.auth().signOut();
    }

    render() {
        return(
            <div>
                <p>Configuracao</p>
                {/* <Logout handleLogout={this.handleLogout} /> */}
            </div>
        );
    }
}

